import { useState } from "react";
import { FaRegHeart, FaHeart } from "react-icons/fa";

const CustomCard = ({ tournament }) => {
  const [isFollowing, setIsFollowing] = useState(false);

  const handleFollow = (e) => {
    e.stopPropagation();
    e.preventDefault();
    setIsFollowing((prev) => !prev);
    // Aquí puedes llamar a tu API para guardar el "follow"
  };

  return (
    <div className="flex items-center bg-white p-4 rounded-2xl shadow-md hover:shadow-lg transition-shadow duration-300 w-full">
      {/* Logo del torneo */}
      <a
        href={tournament.link}
        className="flex-shrink-0 w-20 h-20 bg-gray-100 rounded-xl flex items-center justify-center mr-4"
      >
        <img
          src={tournament.image}
          alt={`Logo de ${tournament.name}`}
          className="w-16 h-16 object-contain"
          onError={(e) => {
            e.target.onerror = null;
            e.target.src =
              "https://images.icon-icons.com/1193/PNG/512/1490877818-sport-badges05_82419.png";
          }}
        />
      </a>

      {/* Info del torneo */}
      <div className="flex-grow overflow-hidden">
        <a href={tournament.link}>
          <h3 className="font-bold text-gray-800 truncate">
            {tournament.name}
          </h3>
          <p className="text-sm text-gray-500">{tournament.category}</p>
          <div
            className={`mt-2 inline-block px-2 py-1 text-xs font-semibold rounded-full ${tournament.statusColor}`}
          >
            {tournament.status}
          </div>
        </a>
      </div>

      {/* Botón de seguir con ícono */}
      <button
        onClick={handleFollow}
        className="ml-4 p-2 rounded-full bg-gray-100 hover:bg-gray-200 transition-colors"
      >
        {isFollowing ? (
          <FaHeart className="text-red-500 text-xl" />
        ) : (
          <FaRegHeart className="text-gray-600 text-xl" />
        )}
      </button>
    </div>
  );
};

export default CustomCard;
